import React, { useEffect, useRef, useState } from 'react'
import axios from "axios";
import { Auth } from "aws-amplify";
import { AlertTitle, Chip, CircularProgress, DialogContent, DialogTitle, IconButton, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Tooltip } from '@mui/material'
import MuiAlert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CancelIcon from '@mui/icons-material/Cancel';
import MusicOffIcon from '@mui/icons-material/MusicOff';
import ErrorIcon from '@mui/icons-material/Error';
import CommentsDisabledIcon from '@mui/icons-material/CommentsDisabled';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import TabletMacIcon from '@mui/icons-material/TabletMac';

import WordPlayback from '../../WordPlayback';

const StudentReport = ( {handleClose, testId, studId, lang, allLangs, thresholds} ) => {
  const [tabValue, setTabValue] = useState(0);
  const [reportJson, setReportJson] = useState("");
  const [error, setError] = useState("");
  const audioRef = useRef([])
  // const cwsnLabels = useMemo(() => (
  //   {
  //     99: "Not Applicable",
  //     1: "1-Blindness",
  //     2: "2-Low-Vision",
  //     3: "3-Hearing impairment",
  //     4: "4-Speech and Language",
  //     5: "5-Locomotor Disability",
  //     6: "6-Mental illness",
  //     7: "7-Specific Learning Disabilities",
  //     8: "8-Cerebral palsy",
  //     9: "9-Autism Spectrum Disorder",
  //     10: "10-Multiple Disability incl. deaf blindness",
  //     11: "11-Leprosy Cured students",
  //     12: "12-Dwarfism",
  //     13: "13-Intellectual Disability",
  //     14: "14-Muscular Dystrophy",
  //     15: "15-Chronic Neurological conditions",
  //     16: "16-Multiple Sclerosis",
  //     17: "17-Thalassemia",
  //     18: "18-Haemophilia",
  //     19: "19-Sickle Cell disease",
  //     20: "20-Acid Attack victim",
  //     21: "21-Parkinson's disease",
  //   }
  // ), []);

  const { t } = useTranslation();

  useEffect(() => {
      Auth.currentSession()
      .then((data) => {
        const jwtToken = data.idToken.jwtToken;
        const demoId = data.idToken.payload["custom:db_id"]

        const getReportData = async(demoId, testId, studId) => {
          try {
            const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/demo/"+demoId+"/student-report?testId="+testId+"&studId="+studId, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwtToken
                }
            });
            // console.log(response.data)
            // console.log("Student Report Data: ", {...response.data, "reportCard": response.data.reportCard.sort((a, b) => a.lang > b.lang ? 1 : -1)})
            setReportJson({...response.data, "reportCard": response.data.reportCard.sort((a, b) => a.lang > b.lang ? 1 : -1)})
            let reportLangs = response.data.reportCard.sort((a, b) => a.lang > b.lang ? 1 : -1).map(item => item.lang)
            // console.log(selectedLang)
            // console.log(reportLangs)
            if(reportLangs.includes(lang)) setTabValue(reportLangs.indexOf(lang))
          }
          catch (error) {
            if(error.response.status === 404) setError({"status": "warning", "msg": t("facilitator.results.studentReportDialogue.error_api_resultNotFound")})
            else{
              setError({"status": "error", "msg": t("commonItems.error_api_generic")})
              console.log(error)
            }
          }
        }

        getReportData(demoId, testId, studId)
      })
      .catch((err) => console.log(err));
  }, [t, testId, studId, lang]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const pauseAudio = (e) => {
    // console.log(e)
    audioRef.current.filter(i => i !== e.target).map((audio => audio.pause()))
  }

  var filteredThresholds = null
  if(thresholds && reportJson!==""){
    filteredThresholds = thresholds[reportJson.reportCard[tabValue].lang].filter(item => item.std === reportJson.studentDetails.grade)[0]
  }
  // console.log(thresholds)

  return (
    <>
      <DialogTitle sx={{display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap"}}>
        <AssessmentIcon color="info" sx={{fontSize: "1.25rem"}}/>
        <b>{t("facilitator.results.studentReportDialogue.title")}</b>
        {/* {reportJson && 
          <p style={{fontWeight: "bold", fontSize: "0.67em", marginLeft: "auto", marginRight: "20px"}}>
            {reportJson.studentDetails.schoolName + " Shift " + reportJson.studentDetails.shift + ", " + reportJson.studentDetails.region}
          </p>
        } */}
        {reportJson && 
          <p style={{fontWeight: "bold", fontSize: "0.67em", marginLeft: "auto", marginRight: "20px"}}>
            {"Grade " + reportJson.studentDetails.grade + ", " + reportJson.studentDetails.region}
          </p>
        }
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <div className='studentReport'>
          {/* <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>Student Report</h2> */}
          {reportJson ?
          <>
            {/* <div className="countTileContainer" style={{padding: "unset"}}>
              <div className="countTile" style={{gap: "0.5rem"}}>
                <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_name")}:</div>
                <div className="countTileRight">{
                  reportJson.ver === "1" ?
                    reportJson.studentDetails.firstName.toUpperCase() + " " + reportJson.studentDetails.lastName.toUpperCase()
                  :
                    reportJson.studentDetails.studentName.toUpperCase()
                }
                </div>
              </div>
              {reportJson.ver === "1" ?
                <div className="countTile" style={{gap: "0.5rem"}}>
                  <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_penNo")}:</div>
                  <div className="countTileRight">{reportJson.studentDetails.id}</div>
                </div>
              :
                <div className="countTile" style={{gap: "0.5rem"}}>
                  <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_orgStudId")}:</div>
                  <div className="countTileRight">{reportJson.studentDetails.orgStudId}</div>
                </div>
              }
              <div className="countTile" style={{gap: "0.5rem"}}>
                <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_class")}:</div>
                <div className="countTileRight">{reportJson.studentDetails.grade}</div>
              </div>
              <div className="countTile" style={{gap: "0.5rem"}}>
                <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_section")}:</div>
                <div className="countTileRight">{reportJson.studentDetails.div}</div>
              </div>
              <div className="countTile" style={{gap: "0.5rem"}}>
                <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_rollNo")}:</div>
                <div className="countTileRight">{reportJson.studentDetails.rollNo}</div>
              </div>
              <div className="countTile" style={{gap: "0.5rem"}}>
                <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_gender")}:</div>
                <div className="countTileRight">{reportJson.studentDetails.gender}</div>
              </div>
              {reportJson.ver !== "1" &&
                <div className="countTile" style={{gap: "0.5rem"}}>
                  <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_cwsnCategory")}:</div>
                  <div className="countTileRight">{cwsnLabels[reportJson.studentDetails.cwsn]}</div>
                </div>
              }
            </div> */}
            <div>
              <Tabs value={tabValue} onChange={handleTabChange} sx={{minHeight: "30px"}}>
                {reportJson.reportCard.map((item, i) => {
                  return <Tab 
                            key = {i}
                            label={Object.keys(allLangs).includes(item.lang) ? allLangs[item.lang] : item.lang} 
                            sx={{fontSize: "inherit", 
                            minHeight: "30px"}}
                          />
                })}
              </Tabs>
            </div>
            <div className="reportContainer">
              <div className="reportContainerLeft">
                <div className="paraContainer paraContainerTop">
                  <div style={{flexBasis: "100%"}}><h4>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_storyRead")}: {reportJson.reportCard[tabValue].storyTitle}</h4></div>
                  <p>
                    {t("facilitator.results.studentReportDialogue.reportDetailsLabel_wcpm") }
                        {" "}
                        <Tooltip 
                          enterTouchDelay={50} 
                          arrow 
                          title={<span className="fontFamily-Montserrat">Words Correct Per Minute. The total number of words correctly read in a minute.</span>}>
                            <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                        </Tooltip>  
                      : {" "}
                      <b>{
                        reportJson.reportCard[tabValue].reportCard.wcpm >= 0 ? 
                        reportJson.reportCard[tabValue].reportCard.wcpm : "NA"
                      }

                      </b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_readingAccuracy")}
                      {" "}
                      <Tooltip 
                        enterTouchDelay={50} 
                        arrow 
                        title={<span className="fontFamily-Montserrat">Percentage of words correctly read.</span>}>
                          <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                      </Tooltip> 
                      : {" "}
                      <b>{
                        reportJson.reportCard[tabValue].reportCard.readingAccuracy >=0 ? 
                        reportJson.reportCard[tabValue].reportCard.readingAccuracy + "%" : "NA"
                      }
                    </b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_pace")}
                      {" "}
                      <Tooltip 
                        enterTouchDelay={50} 
                        arrow 
                        title={<span className="fontFamily-Montserrat">Reading speed</span>}>
                          <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                      </Tooltip> 
                      : {" "}
                      <b>{
                        reportJson.reportCard[tabValue].reportCard.sr !== -1 ? 
                          filteredThresholds ?
                            (
                              parseFloat(reportJson.reportCard[tabValue].reportCard.sr) <= parseFloat(filteredThresholds.paceT1) ? t("commonItems.textLabel_pace1", {pace: reportJson.reportCard[tabValue].reportCard.sr}) :
                              parseFloat(reportJson.reportCard[tabValue].reportCard.sr) <= parseFloat(filteredThresholds.paceT2) ? t("commonItems.textLabel_pace2", {pace: reportJson.reportCard[tabValue].reportCard.sr}) :
                              parseFloat(reportJson.reportCard[tabValue].reportCard.sr) <= parseFloat(filteredThresholds.paceT3) ? t("commonItems.textLabel_pace3", {pace: reportJson.reportCard[tabValue].reportCard.sr}) : 
                              t("commonItems.textLabel_pace4", {pace: reportJson.reportCard[tabValue].reportCard.sr})
                            )
                          :
                            <>
                              Contact TARA Admin 
                              <Tooltip 
                                enterTouchDelay={50} 
                                arrow 
                                title={"Pace cannot be computed"}>
                                  <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                              </Tooltip> 
                            </>
                        : "NA"
                      }</b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_wordMistakes")} 
                    {" "}
                    <Tooltip 
                      enterTouchDelay={50} 
                      arrow 
                      title={<span className="fontFamily-Montserrat">Total number of words which were incorrectly read, omitted and includes words that have not been attempted.</span>}>
                        <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                    </Tooltip> 
                    : {" "}
                    <b>{
                      reportJson.reportCard[tabValue].reportCard.noMiscues !== -1 ? 
                      reportJson.reportCard[tabValue].reportCard.noMiscues : "NA"
                    }
                    </b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_practiceWords")} 
                      {" "}
                      <Tooltip 
                        enterTouchDelay={50} 
                        arrow 
                        title={<span className="fontFamily-Montserrat">Common list of words on which the child has always made mistakes.</span>}>
                          <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                      </Tooltip> 
                      : {" "}
                      <b>{
                        reportJson.reportCard[tabValue].reportCard.practiceWords.length ? 
                        reportJson.reportCard[tabValue].reportCard.practiceWords.toString() : "-"
                      }</b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_phrasing")} 
                      {" "}
                      <Tooltip 
                        enterTouchDelay={50} 
                        arrow 
                        title={<span className="fontFamily-Montserrat">Appropriate grouping of words, pausing at commas and stopping at full stops.</span>}>
                          <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                      </Tooltip> 
                      : {" "}
                      <b>{
                        parseFloat(reportJson.reportCard[tabValue].reportCard.phrasingScore) >=0 ? 
                          filteredThresholds ?
                            (
                              parseFloat(reportJson.reportCard[tabValue].reportCard.phrasingScore) >= parseFloat(filteredThresholds.phrasingT1) ? t("commonItems.textLabel_phrasing1") :
                              parseFloat(reportJson.reportCard[tabValue].reportCard.phrasingScore) >= parseFloat(filteredThresholds.phrasingT2) ? t("commonItems.textLabel_phrasing2") :
                              parseFloat(reportJson.reportCard[tabValue].reportCard.phrasingScore) >= parseFloat(filteredThresholds.phrasingT3) ? t("commonItems.textLabel_phrasing3") : 
                              t("commonItems.textLabel_phrasing4")
                            )
                          :
                            <>
                              Contact TARA Admin 
                              <Tooltip 
                                enterTouchDelay={50} 
                                arrow 
                                title={"Phrasing cannot be computed"}>
                                  <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                              </Tooltip> 
                            </>
                        : <>
                          NA 
                          <Tooltip 
                            enterTouchDelay={50} 
                            arrow 
                            title={"Phrasing is only computed for WCPM>=85 & Reading Accuracy>=90%"}>
                              <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                          </Tooltip> 
                        </>
                      }</b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_improperPhraseBreaks")} <span style={{color: "red"}}><b>||</b></span>
                      {" "}
                      <Tooltip 
                        enterTouchDelay={50} 
                        arrow 
                        title={<span className="fontFamily-Montserrat">Break in reading at non-ideal locations.</span>}>
                          <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                      </Tooltip> 
                      : {" "}
                      <b>{
                        reportJson.reportCard[tabValue].reportCard.phrasingScore >=0 ? 
                        reportJson.reportCard[tabValue].reportCard.phrasingMiscues.i : "NA"
                      }</b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_missedPhraseBreaks")} <span style={{color: "#3E008E"}}><b>||</b></span> 
                      {" "}
                      <Tooltip 
                        enterTouchDelay={50} 
                        arrow 
                        title={<span className="fontFamily-Montserrat">Missing breaks at compulsory locations like full stops.</span>}>
                          <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                      </Tooltip> 
                      : {" "}
                      <b>{
                        reportJson.reportCard[tabValue].reportCard.phrasingScore >=0 ? 
                        reportJson.reportCard[tabValue].reportCard.phrasingMiscues.m : "NA"
                      }</b>
                  </p>
                </div>
                {reportJson.reportCard[tabValue].reportCard.paraResults.map((item, i) => {
                  return <div key = {i} className="paraContainer">
                          <div className="paraDiv">
                            <h4>{t("facilitator.results.studentReportDialogue.paragraphLabel")}: {item.paraNo}</h4>
                            {item.s3Url !== "" && 
                              <audio
                                ref={ref => audioRef.current[i] = ref}
                                onPlaying={(e) => pauseAudio(e)}
                                // onError={(e) => console.log(e)}
                                controls
                                // controlsList="nodownload noplaybackrate"
                                // src={"https://www.ee.iitb.ac.in/LMEDS/audio_examples/KV/audios/27179910008431_1700296121306_Para2-Take1.m4a"}
                                src={item.s3Url}
                                style={{height: "2rem", borderRadius: "10px", border: "1px solid #242d49"}}
                              />
                            }
                            {item.resultStatus === 1 && <Chip icon={<CommentsDisabledIcon/>} color='error' label="Incomplete Attempt" /> }
                            {item.resultStatus === 2 && <Chip icon={<MusicOffIcon/>} color='error' label="Blank Audio" /> }
                            {item.resultStatus === 3 && <Chip icon={<ErrorIcon/>} color='error' label="Missing Audio" /> }
                          </div>
                          <p style={{marginTop: "0.5rem"}}>
                            <WordPlayback
                              key={i}
                              item={item}
                              i={i}
                              audioRef={audioRef}
                            />
                          </p>
                  </div>  
                })}
              </div>
              <div className="reportContainerRight">
                <div className="attemptContainer">
                  <h4>{t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary")}:</h4>
                  {reportJson.reportCard[tabValue].resultStatus ?
                    <Chip icon={<CancelIcon/>} color='error' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_invalid")} />
                    :
                    <Chip icon={<CheckCircleIcon/>} color='success' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_valid")} />
                  }
                  {[0,3,5].includes(reportJson.reportCard[tabValue].reportCard.micConnected) ?
                    <Chip icon={<CancelIcon/>} color='error' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_noEarphone")} />
                  // : reportJson.reportCard[tabValue].reportCard.micConnected === 1 ?
                  :[1,4,6].includes(reportJson.reportCard[tabValue].reportCard.micConnected) ?
                    <Chip icon={<CheckCircleIcon/>} color='success' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_earphone")} />
                  : 
                    <Chip icon={<HelpIcon/>} color='warning' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_earphoneUnknown")} />
                  }
                  {[0,1].includes(reportJson.reportCard[tabValue].reportCard.micConnected) ?
                    <Chip icon={<AndroidIcon/>} color='info' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_android")}/>
                  :[3,4].includes(reportJson.reportCard[tabValue].reportCard.micConnected) ?
                    <Chip icon={<PhoneIphoneIcon/>} color='info' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_apple")} />
                  :[5,6].includes(reportJson.reportCard[tabValue].reportCard.micConnected) ?
                    <Chip icon={<TabletMacIcon/>} color='info' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_apple")} /> 
                  :
                    <Chip icon={<AppleIcon/>} color='info' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_apple")} />
                  }
                </div>
                <div className="legendContainer">
                  <TableContainer style={{width: "unset"}}>
                    <Table size='small'>
                      <TableHead>
                        <TableRow>
                          <TableCell align='center' style={{padding: "6px 6px"}}><h4>{t("facilitator.results.studentReportDialogue.legendLabel_wordMistakes")}</h4></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><span style={{color: "green"}}>{t("facilitator.results.studentReportDialogue.legendLabel_wordMistakes_correct")}</span></TableCell></TableRow>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><span style={{color: "#3E008E"}}>{t("facilitator.results.studentReportDialogue.legendLabel_wordMistakes_substitution")}</span></TableCell></TableRow>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><del>{t("facilitator.results.studentReportDialogue.legendLabel_wordMistakes_deletion")}</del></TableCell></TableRow>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><ins> {t("facilitator.results.studentReportDialogue.legendLabel_wordMistakes_insertion")}</ins></TableCell></TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TableContainer style={{width: "unset"}}>
                    <Table size='small'>
                      <TableHead>
                        <TableRow>
                          <TableCell align='center' style={{padding: "6px 6px"}}><h4>{t("facilitator.results.studentReportDialogue.legendLabel_phraseBreaks")} ||</h4></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><span style={{color: "green"}}>|| - {t("facilitator.results.studentReportDialogue.legendLabel_phraseBreaks_correct")}</span></TableCell></TableRow>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><span style={{color: "red"}}>|| - {t("facilitator.results.studentReportDialogue.legendLabel_phraseBreaks_improper")}</span></TableCell></TableRow>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><span style={{color: "#3E008E"}}>|| - {t("facilitator.results.studentReportDialogue.legendLabel_phraseBreaks_missed")}</span></TableCell></TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </>
          : ( error ?
              <MuiAlert severity={error.status} className="blankScreenError" sx={{borderRadius: "10px"}}>
                <AlertTitle>{error.msg}</AlertTitle>
              </MuiAlert>
              :
              <CircularProgress color="info" style={{placeSelf: "center"}}/>) }
        </div>
      </DialogContent>
    </>
  )
}

export default StudentReport